import React, { forwardRef } from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import { Spinner } from '@flexiflow-ui-kit/spinner';
import styled, { css } from 'styled-components';
import { ArrowDownIcon } from '@flexiflow-ui-kit/icon';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var ButtonVariant;

(function (ButtonVariant) {
  ButtonVariant["Brand"] = "brand";
  ButtonVariant["Primary"] = "primary";
  ButtonVariant["Secondary"] = "secondary";
  ButtonVariant["Danger"] = "danger";
  ButtonVariant["Ghost"] = "ghost";
})(ButtonVariant || (ButtonVariant = {}));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _buttonStyle, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _spinnerStyle, _templateObject26, _templateObject27, _templateObject28;
var buttonStyle$1 = (_buttonStyle = {}, _defineProperty(_buttonStyle, ButtonVariant.Brand, {
  normal: css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n      ", ";\n      background-color: ", ";\n      color: ", ";\n      padding: 4px 16px;\n      height: 32px;\n    "])), function (p) {
    return p.theme.predefinedCss.subTitle3;
  }, function (p) {
    return p.theme.palette.brand.primary;
  }, function (p) {
    return p.theme.palette.white;
  }),
  hover: css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.brand.hover;
  }),
  loading: css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.brand.disabled;
  }),
  disabled: css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.brand.disabled;
  })
}), _defineProperty(_buttonStyle, ButtonVariant.Primary, {
  normal: css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n      ", ";\n      padding: 4px 16px;\n      color: ", ";\n      background-color: ", ";\n      height: 32px;\n    "])), function (p) {
    return p.theme.predefinedCss.subTitle3;
  }, function (p) {
    return p.theme.palette.white;
  }, function (p) {
    return p.theme.palette.gray['800'];
  }),
  hover: css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.gray['900'];
  }),
  disabled: css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.gray['600'];
  }),
  loading: css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), function (p) {
    return p.theme.palette.gray['600'];
  })
}), _defineProperty(_buttonStyle, ButtonVariant.Secondary, {
  normal: css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      ", ";\n      padding: 4px 16px;\n      color: ", ";\n      background-color: ", ";\n      height: 32px;\n    "])), function (p) {
    return p.theme.predefinedCss.subTitle3;
  }, function (p) {
    return p.theme.palette.black;
  }, function (p) {
    return p.theme.palette.gray['100'];
  }),
  hover: css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n    "])), function (p) {
    return p.theme.palette.gray['200'];
  }, function (p) {
    return p.theme.palette.black;
  }),
  disabled: css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n    "])), function (p) {
    return p.theme.palette.gray['100'];
  }, function (p) {
    return p.theme.palette.gray['600'];
  }),
  loading: css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n    "])), function (p) {
    return p.theme.palette.gray['100'];
  }, function (p) {
    return p.theme.palette.gray['600'];
  })
}), _defineProperty(_buttonStyle, ButtonVariant.Danger, {
  normal: css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n      ", ";\n      padding: 4px 16px;\n      color: ", ";\n      background-color: ", ";\n      height: 32px;\n    "])), function (p) {
    return p.theme.predefinedCss.subTitle3;
  }, function (p) {
    return p.theme.palette.white;
  }, function (p) {
    return p.theme.palette.red['800'];
  }),
  hover: css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n    "])), function (p) {
    return p.theme.palette.red['900'];
  }, function (p) {
    return p.theme.palette.white;
  }),
  disabled: css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n    "])), function (p) {
    return p.theme.palette.red['200'];
  }, function (p) {
    return p.theme.palette.white;
  }),
  loading: css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n    "])), function (p) {
    return p.theme.palette.red['200'];
  }, function (p) {
    return p.theme.palette.white;
  })
}), _defineProperty(_buttonStyle, ButtonVariant.Ghost, {
  normal: css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      ", ";\n      padding: 4px 16px;\n      color: ", ";\n      background-color: ", ";\n      height: 32px;\n    "])), function (p) {
    return p.theme.predefinedCss.subTitle3;
  }, function (p) {
    return p.theme.palette.gray['700'];
  }, function (p) {
    return p.theme.palette.white;
  }),
  hover: css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      color: ", ";\n    "])), function (p) {
    return p.theme.palette.gray['100'];
  }, function (p) {
    return p.theme.palette.gray['700'];
  }),
  disabled: css(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (p) {
    return p.theme.palette.gray['700'];
  }),
  loading: css(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), function (p) {
    return p.theme.palette.gray['700'];
  })
}), _buttonStyle);
var spinnerStyle = (_spinnerStyle = {}, _defineProperty(_spinnerStyle, ButtonVariant.Brand, css(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), function (p) {
  return p.theme.palette.white;
})), _defineProperty(_spinnerStyle, ButtonVariant.Primary, css(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), function (p) {
  return p.theme.palette.white;
})), _defineProperty(_spinnerStyle, ButtonVariant.Secondary, css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), function (p) {
  return p.theme.palette.gray['600'];
})), _defineProperty(_spinnerStyle, ButtonVariant.Danger, css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), function (p) {
  return p.theme.palette.white;
})), _defineProperty(_spinnerStyle, ButtonVariant.Ghost, css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "])), function (p) {
  return p.theme.palette.gray['700'];
})), _spinnerStyle);
var Inner = styled.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  visibility: ", ";\n"])), function (p) {
  return p.$loading ? 'hidden' : 'visible';
});
var Button$1 = styled.button(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  ", ";\n  font-family: ", ";\n  ", ";\n  flex-shrink: ", ";\n  width: ", ";\n  position: relative;\n  border-radius: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: ", ";\n  transition: all 0.25s ease;\n\n  border: 0;\n\n  &:hover:enabled {\n    ", ";\n  }\n  &:active:enabled {\n    ", " {\n      transform: translateY(1px);\n    }\n  }\n  &:disabled {\n    ", ";\n  }\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
}, function (p) {
  return p.theme.fonts.text;
}, function (p) {
  return buttonStyle$1[p.$variant].normal;
}, function (p) {
  return p.$growWidth ? 1 : 0;
}, function (p) {
  return p.$growWidth ? '100%' : 'auto';
}, function (p) {
  return p.disabled ? 'not-allowed' : 'pointer';
}, function (p) {
  return buttonStyle$1[p.$variant].hover;
}, Inner, function (p) {
  return p.$loading ? buttonStyle$1[p.$variant].loading : buttonStyle$1[p.$variant].disabled;
});
var Loader = styled(Spinner)(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 8px;\n  border-width: 1px;\n  position: absolute;\n  border-left-color: transparent;\n"])), function (p) {
  return spinnerStyle[p.variant];
});

var _excluded$1 = ["loading", "children", "className", "disabled", "type", "growWidth", "variant"];
var Button = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      children = _ref.children,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$growWidth = _ref.growWidth,
      growWidth = _ref$growWidth === void 0 ? false : _ref$growWidth,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? ButtonVariant.Primary : _ref$variant,
      otherProps = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(Button$1, _extends({
    ref: forwardedRef,
    $variant: variant,
    $growWidth: growWidth,
    $loading: loading,
    className: className,
    type: type,
    disabled: disabled || loading
  }, otherProps), loading && /*#__PURE__*/React.createElement(Loader, {
    variant: variant
  }), /*#__PURE__*/React.createElement(Inner, {
    $variant: variant,
    $loading: loading
  }, children)));
});

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var buttonStyle = {
  "default": css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (p) {
    return p.theme.palette.gray['700'];
  }, function (p) {
    return p.theme.palette.white;
  }, function (p) {
    return p.theme.palette.gray['200'];
  }),
  hover: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (p) {
    return p.theme.palette.gray['700'];
  }, function (p) {
    return p.theme.palette.gray['200'];
  }, function (p) {
    return p.theme.palette.gray['200'];
  }),
  selected: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (p) {
    return p.theme.palette.blue['600'];
  }, function (p) {
    return p.theme.palette.blue['50'];
  }, function (p) {
    return p.theme.palette.blue['50'];
  }),
  selectedHover: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  "])), function (p) {
    return p.theme.palette.blue['600'];
  }, function (p) {
    return p.theme.palette.blue['100'];
  }, function (p) {
    return p.theme.palette.blue['100'];
  })
};
var FilterButton$1 = styled.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  border-radius: 3px;\n  height: 32px;\n  padding: 4px 14px 4px 16px;\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: ", ";\n  font-family: ", ";\n  width: auto;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  border: 1px solid;\n  margin: 0;\n  cursor: pointer;\n  ", ";\n\n  :hover {\n    ", ";\n  }\n\n  :disabled {\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
}, function (p) {
  return p.theme.fontWeights.semiBold;
}, function (p) {
  return p.theme.fonts.text;
}, function (p) {
  return p.$isExpanded && p.$isSelected && buttonStyle.selectedHover || p.$isSelected && !p.$isExpanded && buttonStyle.selected || !p.$isSelected && p.$isExpanded && buttonStyle.hover || buttonStyle["default"];
}, function (p) {
  return p.$isSelected ? buttonStyle.selectedHover : buttonStyle.hover;
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['500'];
});

var _excluded = ["children", "className", "type", "isSelected", "isExpanded"];
var FilterButton = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(FilterButton$1, _extends({
    ref: forwardedRef,
    className: className,
    type: type,
    $isExpanded: isExpanded,
    $isSelected: isSelected
  }, otherProps), children, /*#__PURE__*/React.createElement(ArrowDownIcon, {
    width: 8,
    height: 5
  })));
});

export { Button, ButtonVariant, FilterButton };
